var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchTeamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7923 22.7103L16.5469 15.5328C19.7295 11.8397 19.5486 6.26379 16.0405 2.75172C14.2322 0.905172 11.8091 0 9.42219 0C7.03524 0 4.61212 0.905172 2.76767 2.75172C-0.921253 6.44483 -0.921253 12.3828 2.76767 16.0759C4.57596 17.8862 6.99907 18.8276 9.42219 18.8276C11.5921 18.8276 13.7983 18.0672 15.5342 16.5466L22.7797 23.7603C22.8882 23.869 23.069 23.9414 23.2498 23.9414C23.4306 23.9414 23.6115 23.869 23.7561 23.7241C24.0455 23.4707 24.0455 23 23.7923 22.7103ZM3.78031 15.0259C2.26134 13.5414 1.4657 11.5138 1.4657 9.41379C1.4657 7.31379 2.29751 5.28621 3.78031 3.76552C5.29928 2.24483 7.2884 1.44828 9.42219 1.44828C11.556 1.44828 13.5451 2.28103 15.0641 3.76552C16.5469 5.28621 17.3787 7.27759 17.3787 9.41379C17.3787 11.55 16.5469 13.5414 15.0641 15.0621C13.5451 16.5466 11.5198 17.3793 9.42219 17.3793C7.32457 17.3793 5.29928 16.5466 3.78031 15.0259Z",
    fill: "#6A7988"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTeamIcon);
export default __webpack_public_path__ + "static/media/search-team-icon.6af998fbf0d0a6c496f34e7992c8da4d.svg";
export { ForwardRef as ReactComponent };